import { type IMapOf } from 'src/types';

import {
  COLLECTION_BASE_PATH,
  getMyMusicPath,
  isPathInNowPlayingPath,
  MY_MUSIC_BASE_PATH,
  stripTrailingSlash,
} from './shared';

export function getCollectionPath() {
  return `${COLLECTION_BASE_PATH}` as const;
}

export function getCollectionSongsPath() {
  return `${COLLECTION_BASE_PATH}/songs` as const;
}

export function getCollectionStationsPath() {
  return `${COLLECTION_BASE_PATH}/stations` as const;
}

export function getCollectionFilterPath(filter: string) {
  return `${COLLECTION_BASE_PATH}/${filter}` as const;
}

export function getCollectionArtistPath(artistId: string) {
  return `${COLLECTION_BASE_PATH}/artists/${artistId}` as const;
}

export function getMyMusicFilteredSongsPath() {
  return `${MY_MUSIC_BASE_PATH}/songs` as const;
}

export function isCollectionSongsPath(path: string, includeMyMusic = false): boolean {
  let isPath = /^\/collection\/songs$/.test(path);
  if (!isPath && includeMyMusic) {
    isPath = getMyMusicFilteredSongsPath() === path;
  }
  return isPath;
}

export function isMyMusicPath(path: string): boolean {
  return /^\/my-music(\/(all|artists|albums|songs|stations|playlists))?$/.test(path);
}

export function isCollectionPath(path: string): boolean {
  return /^\/collection(\/(all|artists|albums|songs|stations|playlists|podcasts|episodes)(\/.*)?)?$/.test(
    path,
  );
}

export function isPodcastCollectionPath(path: string): boolean {
  return /^\/(collection|my-music)(\/(podcasts|episodes)(\/.*)?)?$/.test(path);
}

export function getCollectionPageType(path: string): string {
  return path.split('collection/')[1];
}

export function getMyMusicPageType(path: string): string {
  return path.split('my-music/')[1];
}

// My Music artist sub-page path builder
export function getMyMusicArtistPath(pathname: string, artistAnnotation: IMapOf<$TSFixMe>): string {
  return stripTrailingSlash(pathname) + '/' + artistAnnotation.get('pandoraId');
}

export function isPathInMyMusic(path: string): boolean {
  const myMusic = getMyMusicPath();
  return !isPathInNowPlayingPath(path) && (path === myMusic || path.indexOf(myMusic + '/') === 0);
}
